import { GsFormSchema } from '../../../components';
import { ACTIVE_SCHEMA_FIELDS } from './../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/** Form schema for the ShareLinkUnavailable component settings in the designer. */
export const SHARE_LINK_UNAVAILABLE_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    ...ACTIVE_SCHEMA_FIELDS,
  ],
};
